import { render } from "./preload.vue?vue&type=template&id=6060533a"
const script = {}

import "./preload.vue?vue&type=style&index=0&id=6060533a&lang=scss"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__